import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Right-to-Know Annual Registration Form": {
    parameters: {
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      linkUrls: [
        "https://dlt.ri.gov/regulation-and-safety/occupational-safety/right-know-guidelines-employers-register",
      ],
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "RI",
  },
};
